import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, message, Modal, notification} from 'antd'
import {ObjectInspector} from 'react-inspector'
import GenerateResuls from "./GenerateResuls"
import {generatePrintOrderByQuery} from "../../../../../services/api/3dApi"

class GenerateTemplateByQuery extends Component {
    state = {
        isOpen: true,
    }

    _generateTemplates = async () => {
        try {
            const payload = {
                query: this.props.query,
            }

            const {data: response} = await generatePrintOrderByQuery(payload)

            const {success, data, error} = response

            if (!success) {
                throw new Error(error)
            }

            this.setState({
                isOpen: false,
            }, () => {
                message.loading('Action in the background.')
                notification.success({
                    message: 'Kết quả',
                    description: <GenerateResuls data={data}/>,
                    duration: 10
                })
            })
        } catch (e) {
            message.error(`ERROR: ${e.message}`, 5)
        }
    }

    _renderModalFooter = () => {
        const buttonCancel = <Button key='btnCancelBulkAction1' onClick={this._closeModal}>Cancel</Button>
        const buttonOk = <Button key='btnOKBulkAction1' type='primary' onClick={this._generateTemplates}>OK</Button>

        return [buttonCancel, buttonOk]
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    _handleAfterClose = () => {
        this.props.onResetAction()
    }

    render() {
        const {isOpen} = this.state
        const modalFooter = this._renderModalFooter()

        return (
            <Modal visible={isOpen} title='Please confirm' className='GenerateTemplateByQuery'
                   afterClose={this._handleAfterClose} footer={modalFooter} onCancel={this._closeModal}>
                <div className='mb-3'>
                    <ObjectInspector data={this.props.query} expandLevel={1}/>
                </div>

                <div>
                    Bạn có chắc muốn tạo file in <strong>{this.props.total}</strong> items?
                </div>
            </Modal>
        )
    }
}

GenerateTemplateByQuery.propTypes = {
    query: PropTypes.object.isRequired,
    total: PropTypes.number.isRequired,
    onResetAction: PropTypes.func.isRequired,
}

export default GenerateTemplateByQuery
